import '@hotwired/turbo-rails'
import '@rails/actiontext'
import 'trix'

import './controllers'

document.addEventListener('click', (event) => {
  const anchor = event.target.closest('a')

  if (anchor && anchor.closest('.trix-content') && anchor.host !== window.location.host) {
    anchor.setAttribute('target', '_blank')
    anchor.setAttribute('rel', 'noreferrer')
  }
})
